import RestaurantDesignerHandler from './RestaurantDesignerHandler'
import { listRestaurantProject } from 'sections/options/sections/RestaurantDesigner/queries'
import {
	rawCreateProject, rawUpdateProject, rawDeleteProject,
	rawCreateFloor, rawUpdateFloor, rawDeleteFloor,
	rawCreateRoom, rawUpdateRoom, rawDeleteRoom,
	rawCreateFurniture,	rawUpdateFurniture, rawDeleteFurniture
} from './mutations'

export default t => ({
	label: t('options_section.sub_sections.restaurant_designer'),
	// typename: 'RestaurantDesigner',
	link: 'restaurantDesigner',
	handler: RestaurantDesignerHandler,
	mutations: {
		create: {
			rawCreateProject,
			rawCreateFloor,
			rawCreateRoom,
			rawCreateFurniture
		},
		update: {
			rawUpdateProject,
			rawUpdateFloor,
			rawUpdateRoom,
			rawUpdateFurniture
		},
		delete: {
			rawDeleteProject,
			rawDeleteFloor,
			rawDeleteRoom,
			rawDeleteFurniture
		}
	},
	query: listRestaurantProject
})
